export const numToCurrency = (amount = 0, numOfDecimal = 0) => {
  const safeDecimal = Math.max(0, Math.min(20, Number(numOfDecimal) || 0)); // Clamp to 0–20
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: safeDecimal,
    maximumFractionDigits: safeDecimal
  }).format(amount);
};
